var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "bl-token-attribute-group",
      class: { well: !_vm.isRoot },
      attrs: { id: _vm.model.id },
    },
    [
      _vm._l(_vm.model.entries, function (entry, index) {
        return [
          index > 0
            ? _c(
                "div",
                {
                  key: `operator-${entry.id}`,
                  staticClass: "bl-token-attribute-group-label",
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.currentOperatorOption.label) +
                      "\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCqlAttributeData(entry)
            ? _c("CqlAttribute", {
                key: entry.id,
                attrs: { options: _vm.options },
                on: {
                  "add-attribute-group": function ($event) {
                    return _vm.addAttribute($event, entry)
                  },
                  "delete-attribute": function ($event) {
                    return _vm.deleteAttribute(entry.id)
                  },
                },
                model: {
                  value: _vm.model.entries[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.model.entries, index, $$v)
                  },
                  expression: "model.entries[index]",
                },
              })
            : _vm.isCqlAttributeGroupData(entry)
            ? _c("CqlAttributeGroup", {
                key: entry.id,
                attrs: { "is-root": false, options: _vm.options },
                on: { "delete-group": _vm.deleteNestedGroup },
                model: {
                  value: _vm.model.entries[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.model.entries, index, $$v)
                  },
                  expression: "model.entries[index]",
                },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.shouldShowAddControls
        ? _c("CqlAddAttributeButton", {
            attrs: { options: _vm.options },
            on: {
              click: function ($event) {
                return _vm.addAttribute($event)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }